import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "flex-center loginPage"
};
const _hoisted_2 = {
  key: 0,
  class: "left"
};
const _hoisted_3 = {
  class: "login-box"
};
const _hoisted_4 = {
  class: "input-form"
};
const _hoisted_5 = {
  class: "flex w100"
};
const _hoisted_6 = {
  class: "flex w100"
};
const _hoisted_7 = {
  key: 1,
  class: "tip-result left"
};
const _hoisted_8 = {
  class: "wechat-card"
};
const _hoisted_9 = {
  class: "mt-3"
};
import { ref } from "vue";
import AccountTop from "@/components/AccountTop.vue";
import AccountBg from "@/components/AccountBg.vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import SendMsg from "@/components/SendMsg.vue";
import { arrayContains, isMobile } from "@/utils/libs";
import { validateEmail, validateMobile } from "@/utils/validate";
import { showMessageError, showMessageOK } from "@/utils/dialog";
import { getLicenseInfo, getSystemInfo } from "@/store/cache";
import Captcha from "@/components/Captcha.vue";
import * as authUtil from '@/utils/auth';
const scene = 22;
// 处理 readonly 状态，防止自动填充
export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {
    const router = useRouter();
    const title = ref("");
    const logo = ref("");
    const data = ref({
      username: "",
      mobile: "",
      email: "",
      password: "",
      vcode: "",
      repass: "",
      invite_code: router.currentRoute.value.query["invite_code"]
    });
    const enableMobile = ref(false);
    const enableEmail = ref(false);
    const enableUser = ref(false);
    const enableRegister = ref(true);
    const activeName = ref("mobile");
    const wxImg = ref("/images/wx.png");
    const licenseConfig = ref({});
    const enableVerify = ref(false);
    const captchaRef = ref();
    const userType = router.currentRoute.value.query["type"];
    const removeReadonly = event => {
      const target = event.target;
      target.removeAttribute('readonly');
    };
    // 记录邀请码点击次数
    if (data.value.invite_code) {
      httpGet("/invite/hits", {
        code: data.value.invite_code
      });
    }
    // 获取租户 ID
    const loadTenantId = async () => {
      if (userType === 'enterprise') {
        // const res = await LoginApi.getTenantIdByCode(form.value.tenantCode)
        // if (!res) {
        //   showMessageInfo("租户编码不存在！");
        //   return false
        // }
        // authUtil.setTenantId(res)
      } else {
        authUtil.setTenantId(1);
      }
      return true;
    };
    getSystemInfo().then(res => {
      if (res.data) {
        title.value = res.data.title;
        logo.value = res.data.logo;
        const registerWays = res.data["register_ways"];
        if (arrayContains(registerWays, "username")) {
          enableUser.value = true;
          activeName.value = "username";
        }
        if (arrayContains(registerWays, "email")) {
          enableEmail.value = true;
          activeName.value = "email";
        }
        if (arrayContains(registerWays, "mobile")) {
          enableMobile.value = true;
          activeName.value = "mobile";
        }
        // 是否启用注册
        enableRegister.value = res.data["enabled_register"];
        // 使用后台上传的客服微信二维码
        if (res.data["wechat_card_url"] !== "") {
          wxImg.value = res.data["wechat_card_url"];
        }
        enableVerify.value = res.data["enabled_verify"];
      }
    }).catch(e => {
      ElMessage.error("获取系统配置失败：" + e.message);
    });
    getLicenseInfo().then(res => {
      licenseConfig.value = res.data;
    }).catch(e => {
      showMessageError("获取 License 配置：" + e.message);
    });
    // 注册操作
    const submitRegister = async () => {
      if (activeName.value === "username" && data.value.username === "") {
        return showMessageError("请输入用户名");
      }
      if (activeName.value === "mobile" && !validateMobile(data.value.mobile)) {
        return showMessageError("请输入合法的手机号");
      }
      if (activeName.value === "email" && !validateEmail(data.value.email)) {
        return showMessageError("请输入合法的邮箱地址");
      }
      if (data.value.password.length < 8) {
        return showMessageError("密码的长度为8-16个字符");
      }
      if (data.value.repass !== data.value.password) {
        return showMessageError("两次输入密码不一致");
      }
      if ((activeName.value === "mobile" || activeName.value === "email") && data.value.vcode === "") {
        return showMessageError("请输入验证码");
      }
      // 如果是用户名和密码登录，那么需要加载验证码
      if (enableVerify.value && activeName.value === "username") {
        captchaRef.value?.loadCaptcha();
      } else {
        await doSubmitRegister({});
      }
    };
    const doSubmitRegister = async verifyData => {
      // data.value.key = verifyData.key;
      // data.value.dots = verifyData.dots;
      // data.value.x = verifyData.x;
      // data.value.reg_way = activeName.value;
      // 加载租户ID
      await loadTenantId();
      httpPost("/system/auth/cu-register", data.value).then(res => {
        authUtil.setToken(res);
        showMessageOK("注册成功，即将跳转到对话主界面...");
        if (isMobile()) {
          router.push("/mobile/index");
        } else {
          router.push("/");
        }
      }).catch(e => {
        showMessageError("注册失败，" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_result = _resolveComponent("el-result");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [enableRegister.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(AccountTop, {
        title: "注册"
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        model: data.value,
        class: "form"
      }, {
        default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("input", {
          type: "text",
          style: {
            "display": "none!important"
          },
          tabindex: "-1",
          autocomplete: "off"
        }, null, -1)), _cache[20] || (_cache[20] = _createElementVNode("input", {
          type: "password",
          style: {
            "display": "none!important"
          },
          tabindex: "-1",
          autocomplete: "off"
        }, null, -1)), _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => activeName.value = $event)
        }, {
          default: _withCtx(() => [enableMobile.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: "手机注册",
            name: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "form-title"
              }, "手机号码", -1)), _createVNode(_component_el_input, {
                placeholder: "请输入手机号码",
                size: "large",
                modelValue: data.value.mobile,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.mobile = $event),
                maxlength: "11",
                autocomplete: `nope`,
                name: `mobile_${Math.random().toString(36).substr(2, 9)}`,
                id: `mobile_${Math.random().toString(36).substr(2, 9)}`,
                onFocus: removeReadonly
              }, null, 8, ["modelValue", "name", "id"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("div", {
                class: "form-title"
              }, "验证码", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
                placeholder: "请输入验证码",
                size: "large",
                maxlength: "6",
                class: "code-input",
                modelValue: data.value.vcode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.value.vcode = $event),
                autocomplete: `nope-${Date.now()}`,
                name: `vcode_${Math.random().toString(36).substr(2, 9)}`,
                id: `vcode_${Math.random().toString(36).substr(2, 9)}`
              }, null, 8, ["modelValue", "autocomplete", "name", "id"]), _createVNode(SendMsg, {
                size: "large",
                receiver: data.value.mobile,
                scene: scene,
                type: "mobile"
              }, null, 8, ["receiver"])])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), enableEmail.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: "邮箱注册",
            name: "email",
            disabled: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              class: "block"
            }, {
              default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("div", {
                class: "form-title"
              }, "邮箱", -1)), _createVNode(_component_el_input, {
                placeholder: "请输入邮箱地址",
                size: "large",
                modelValue: data.value.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.value.email = $event),
                autocomplete: "off"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              class: "block"
            }, {
              default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("div", {
                class: "form-title"
              }, "验证码", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_input, {
                placeholder: "请输入验证码",
                size: "large",
                maxlength: "30",
                class: "code-input",
                modelValue: data.value.vcode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.value.vcode = $event),
                autocomplete: "off"
              }, null, 8, ["modelValue"]), _createVNode(SendMsg, {
                size: "large",
                receiver: data.value.email,
                type: "email"
              }, null, 8, ["receiver"])])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), enableUser.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            label: "用户名注册",
            name: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              class: "block"
            }, {
              default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("div", {
                class: "form-title"
              }, "用户名", -1)), _createVNode(_component_el_input, {
                placeholder: "请输入用户名",
                size: "large",
                modelValue: data.value.username,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.value.username = $event),
                autocomplete: "off"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_form_item, {
          class: "block"
        }, {
          default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "form-title"
          }, "密码", -1)), _createVNode(_component_el_input, {
            placeholder: "请输入密码(8-16位)",
            maxlength: "16",
            size: "large",
            modelValue: data.value.password,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.value.password = $event),
            "show-password": "",
            autocomplete: `new-password-${Date.now()}`,
            name: `password_${Math.random().toString(36).substr(2, 9)}`,
            id: `password_${Math.random().toString(36).substr(2, 9)}`
          }, null, 8, ["modelValue", "autocomplete", "name", "id"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "block"
        }, {
          default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "form-title"
          }, "重复密码", -1)), _createVNode(_component_el_input, {
            placeholder: "请再次输入密码(8-16位)",
            size: "large",
            maxlength: "16",
            modelValue: data.value.repass,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.value.repass = $event),
            "show-password": "",
            autocomplete: `new-password-repeat-${Date.now()}`,
            name: `repass_${Math.random().toString(36).substr(2, 9)}`,
            id: `repass_${Math.random().toString(36).substr(2, 9)}`
          }, null, 8, ["modelValue", "autocomplete", "name", "id"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "block"
        }, {
          default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", {
            class: "form-title"
          }, "邀请码", -1)), _createVNode(_component_el_input, {
            placeholder: "请输入邀请码(可选)",
            size: "large",
            modelValue: data.value.invite_code,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.value.invite_code = $event),
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "btn-row",
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "login-btn",
              type: "primary",
              size: "large",
              onClick: submitRegister
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("注册")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_result, {
        icon: "error",
        title: "注册功能已关闭"
      }, {
        "sub-title": _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("p", null, "抱歉，系统已关闭注册功能，请联系管理员添加账号！", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_image, {
          src: wxImg.value
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = $event => _unref(router).push('/'))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("i", {
            class: "iconfont icon-home mr-1"
          }, null, -1), _createTextVNode(" 返回首页")])),
          _: 1
        })])]),
        _: 1
      })])), enableVerify.value ? (_openBlock(), _createBlock(Captcha, {
        key: 2,
        onSuccess: doSubmitRegister,
        ref_key: "captchaRef",
        ref: captchaRef
      }, null, 512)) : _createCommentVNode("", true), _createVNode(AccountBg)])]);
    };
  }
});